/* eslint-disable quotes */
import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { EventEmitter } from 'events';
import { ServerInfo } from './serverinfo.model';
import { Router } from '@angular/router';
import { environment } from '../../../environments/environment';

@Injectable({ providedIn: 'root' })
export class ServerInfoService {

    $serverInfo: BehaviorSubject<ServerInfo> = new BehaviorSubject(null);
    private isFetching: boolean;
    private lock = new EventEmitter();
    private baseUrl: string = environment.dist ? `/json` : `${environment.BASE_URL}/json`;

    constructor(
        private http: HttpClient,
        private router: Router,
    ) {
    }

    async fetchServerInfo(): Promise<ServerInfo> {
        if (this.isFetching) {
            await new Promise<void>(resolve => this.lock.once('unlocked', resolve));
        }
        return new Promise((resolve, reject) => {
            if (!this.$serverInfo.getValue()) {
                this.isFetching = true;
                this.http.get<ServerInfo>(`${this.baseUrl}/serverInfo`).subscribe({
                    next: (serverInfo) => {
                        this.$serverInfo.next(serverInfo);
                        this.isFetching = false;
                        this.lock.emit('unlocked');
                        resolve(serverInfo);
                    },
                    error: (error) => {
                        this.isFetching = false;
                        this.lock.emit('unlocked');
                        this.router.navigate(['/500']);
                        reject(error);
                    }
                });
            } else {
                resolve(this.$serverInfo.getValue());
            }
        });
    }

    getServerInfoObservable() {
        return this.$serverInfo;
    }
}
